__turbopack_context__.v({
  "divider": "ddSKja_divider",
  "header": "ddSKja_header",
  "primary": "ddSKja_primary",
});
